export default "__VITE_ASSET__CDM8MRXd__"